module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('yd-layout', [(_vm.showHeader) ? _c('yd-navbar', {
    staticStyle: {
      "top": "-1px"
    },
    attrs: {
      "title": _vm.title,
      "fontsize": _vm.fontsize,
      "bgcolor": _vm.bgcolor,
      "color": _vm.color,
      "height": _vm.height,
      "fixed": _vm.fixed
    }
  }, [_c('div', {
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }, [_vm._t("header-left")], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_vm._t("header-right")], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "main-container"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.showFooter) ? _c('yd-tabbar', {
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "fixed": "",
      "fontsize": "0.28rem"
    }
  }, [_vm._t("tabbar", function() {
    return [_c('yd-tabbar-item', {
      attrs: {
        "title": "首页",
        "link": "/home"
      }
    }, [_c('yd-icon', {
      attrs: {
        "slot": "icon",
        "name": "home",
        "size": "0.5rem"
      },
      slot: "icon"
    })], 1), _vm._v(" "), _c('yd-tabbar-item', {
      attrs: {
        "title": "其他",
        "link": "/shopcart"
      }
    }, [_c('yd-icon', {
      attrs: {
        "slot": "icon",
        "name": "shopcart-outline",
        "size": "0.5rem"
      },
      slot: "icon"
    })], 1), _vm._v(" "), _c('yd-tabbar-item', {
      attrs: {
        "title": "个人中心",
        "link": "/ucenter"
      }
    }, [_c('yd-icon', {
      attrs: {
        "slot": "icon",
        "name": "ucenter-outline",
        "size": "0.5rem"
      },
      slot: "icon"
    }), _vm._v(" "), _c('yd-badge', {
      attrs: {
        "slot": "badge",
        "type": "danger"
      },
      slot: "badge"
    }, [_vm._v("2")])], 1)]
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3eb605c8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppLayout/index.vue
// module id = 27
// module chunks = 231